import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    container: {
        position: 'relative',
        height: '100vh',
        width: '100vw',
    },
    overlayContainer: {
        position: 'absolute',
        top: theme.spacing(2),
        left: theme.spacing(2),
        right: theme.spacing(2),
        fontFamily: `Karla, ${theme.typography.fontFamily}`,
        width: 'calc(60% - 2rem)',
        [theme.breakpoints.down(720)]: {
            top: theme.spacing(1),
            left: theme.spacing(1),
            right: theme.spacing(1),
            width: 'calc(100% - 1rem)',
        },
    },
}));
